import { render, staticRenderFns } from "./TemplateVaults.vue?vue&type=template&id=371b0e64"
import script from "./TemplateVaults.vue?vue&type=script&lang=js"
export * from "./TemplateVaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports